import { capitalize } from './text';
/**
 * How a carried Empyreal Crystal stack shows in the inventory UI: named and
 * described by the recipe that coalesced it, since recipes that share a type
 * and size (Vitality Courage and Sorrow) do different things.
 */
import { getRecipeSystem } from '@sorrem/shared';
import type { EmpyrealCrystalItem } from '@sorrem/shared';
import type { UIInventoryItem } from '@sorrem-client/types';


/** A crystal stack as an inventory item. `id` defaults to the stack's own id. */
export function toUICrystalItem(crystal: EmpyrealCrystalItem, id: string = crystal.id): UIInventoryItem {
    const recipe = getRecipeSystem().getRecipe(crystal.recipeId);
    return {
        id,
        itemDefinitionId: `empyreal-crystal:${crystal.recipeId}`,
        name: recipe?.name ?? `${capitalize(crystal.crystalType)} ${capitalize(crystal.size)}`,
        type: 'consumable',
        rarity: 'common',
        qty: crystal.quantity,
        crystal: {
            recipeId: crystal.recipeId,
            crystalType: crystal.crystalType,
            size: crystal.size,
            ...(recipe?.description ? { description: recipe.description } : {}),
        },
    };
}
